<template>
  <div class="skeleton-loader-btn"></div>
</template>

<script>
export default {
  name: 'RetentionCardBtnSkeleton',
}
</script>

<style lang="scss" scoped>
.skeleton-loader-btn {
  width: 116px;
  height: 22px;
  background-color: varFigma(neutral-95-lightest);
  border-radius: 8px;
}
</style>
